import { render, staticRenderFns } from "./gwzButton.vue?vue&type=template&id=7ad1d89a&scoped=true"
import script from "./gwzButton.vue?vue&type=script&lang=js"
export * from "./gwzButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad1d89a",
  null
  
)

export default component.exports